const getFullElementHeight = (element: HTMLElement): number => {
  const computedStyle = window.getComputedStyle(element);
  const marginTop = parseFloat(computedStyle.marginTop) || 0;
  const marginBottom = parseFloat(computedStyle.marginBottom) || 0;
  const fullHeight = element.offsetHeight + marginTop + marginBottom;
  return fullHeight;
};

export const getAdjustedHeight = (activeTab = "applied"): number => {
  const windowHeight = window.innerHeight;
  const headerElement = document.getElementById("dashboard-header");
  const headerHeight = headerElement ? getFullElementHeight(headerElement) : 0;
  const globalHeaderOffSet = 65;

  const combinedHeight = headerHeight + globalHeaderOffSet;
  const remaining = windowHeight - combinedHeight;
  return remaining;
};
